import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_USERS } from "./apiRoutes";

interface UseValidateUserDataProps {
  params: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getUserById = async (params: any) =>
  await axiosAuth.get(`${GET_USERS}/check`, { params });

const useValidateUserData = ({
  params,
  queryParams,
}: UseValidateUserDataProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["user", params],
    queryFn: () => getUserById(params),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!params,
    ...queryParams,
  });
};

export default useValidateUserData;
